import { FiltersCheckBox } from "./FiltersCheckBox"
import { Accordion } from "./Accordion";

type Props = {
    keyword: string;
    filterOptions: { value: string, isSelected: boolean, name: string, keyWordTitle: string }[];
    handleChooseFilter: (item: { value: string, isSelected: boolean }, isMultiSelect?: boolean) => () => void;
    orientation?: "vertical" | "horizontal";
}

export const MultiChoiceFilters: React.FC<Props> = ({ keyword, filterOptions, handleChooseFilter, orientation = "vertical" }) => {

    if (filterOptions.length === 0) {
        return <></>;
    }

    return (
        <Accordion
            title={filterOptions[0].keyWordTitle}
            defaultOpen={false}
        >
            <div
                id={`choose-treatment-multi-choice-filters-${keyword}`}
                style={{
                    ...(orientation === "horizontal" && {
                        display: "grid",
                        gridAutoFlow: "column",
                        gridTemplateColumns: "repeat(auto-fill, 1fr)",
                        justifyItems: "space-between"
                    })
                }}
            >
                {filterOptions.map((item, idx) => (
                    <div
                        key={idx}
                        id={`filter_${item.value}_${idx}`}
                        onClick={handleChooseFilter(item)}
                        style={{
                            borderBottom: idx === filterOptions.length - 1 || orientation === "horizontal" ? 'none' : '1px solid #F9F8F6',
                            ...(orientation === "horizontal" && { justifyContent: idx === 0 ? "flex-start" : idx === filterOptions.length - 1 ? "flex-end" : "center" })
                        }}
                        className='
                            flex 
                            items-center 
                            gap-2 
                            py-3
                            md:py-5 
                            cursor-pointer'
                    >
                        <FiltersCheckBox isSelected={item.isSelected} />
                        <p className="capitalize">{item.name}</p>
                    </div>
                ))}
            </div>
        </Accordion>
    )
}